<template>
  <div v-if="loading" class="shade">
    <b-spinner></b-spinner>
    <div class="message">Please wait...</div>
  </div>
</template>

<script>
export default {
  props: ['loading']
}
</script>

<style scoped>
  .shade {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;
    align-items: center;
    justify-content: center;

    background: radial-gradient(#FFF, rgba(255, 255, 255, 0.5));
  }

  .message {
    margin-left: 1em;

    font-size: 1.5em;
    font-weight: bold;
    color: #666;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
</style>
